import React from "react";
import Input from "../form/Input";
import Button from "../form/Button";
import Image from "../elements/Image";
import OrderSummeryProductDetails from "../Items/OrderSummeryProductDetails";
import { country } from "../../helpers";

const OrderSummary = ({ myCheckoutData }) => {
  const productSummery = myCheckoutData && myCheckoutData?.cartList?.length > 0 ? myCheckoutData?.cartList : [];

  const orderSummaryData = {
    cartSummary: myCheckoutData && myCheckoutData?.cartSummary && myCheckoutData?.cartSummary,
    orderSummary: myCheckoutData && myCheckoutData?.orderSummary && myCheckoutData?.orderSummary,
  };

  return (
    <>
      <div className="xl:w-2/5 w-full xl:pl-16 pl-0  xl:block flex xl:justify-normal justify-center">
        <div className="sticky top-32 w-11/12 bg-gray-50 md:px-7 px-4 py-7 shadow-md">
          <div className="md:text-2xl text-xl uppercase font-bold text-slate-700 pb-1">Product Summary</div>
          <hr className="w-full border-1 border-slate-500 pb-8"></hr>
          <div className="max-h-96 overflow-auto pr-2">
            {productSummery?.length > 0 && (
              <div className="relative space-y-5">
                {productSummery?.map((item, index) => (
                  <OrderSummeryProductDetails key={index} data={item} />
                ))}
              </div>
            )}
          </div>
          <hr className="w-full border-1 border-slate-500 pb-4"></hr>
          <div className="relative border border-slate-300 rounded-md p-2">
            <p className="text-sm font-semibold">
              Delivery Charge:{" "}
              {orderSummaryData?.orderSummary?.deliveryCharges === 0.0
                ? "Free"
                : country + " " + orderSummaryData?.orderSummary?.deliveryCharges.toFixed(2)}
            </p>
            <p className="text-sm font-semibold">Free Delivery on Order of 50 Packages or more</p>
          </div>

          <div>
            <div className="md:text-2xl text-xl uppercase pt-10 pb-1 font-bold text-slate-700">Order Summary</div>
            <hr className="w-full border-1 border-slate-500 pb-5"></hr>
            <div className="space-y-2 ">
              <div className="flex w-full">
                <div className="w-full text-sm font-semibold text-gray-600">Sub Total</div>
                <div className="w-full flex justify-end text-sm font-semibold text-gray-600 uppercase">
                  {country + " " + (orderSummaryData?.cartSummary?.totalCartValue.toFixed(2) || "0")}
                </div>
              </div>
              <div className="flex w-full">
                <div className="w-full text-sm font-semibold text-gray-600">
                  GST/HST Charge ({orderSummaryData?.orderSummary?.taxPercentage}%)
                </div>
                <div className="w-full flex justify-end text-sm font-semibold text-gray-600 uppercase">
                  {country + " " + (orderSummaryData?.orderSummary?.taxCharges.toFixed(2) || "0.00")}
                </div>
              </div>
              <div className="flex w-full">
                <div className="w-full text-sm font-semibold text-gray-600">Delivery Charge</div>
                <div className="w-full flex justify-end text-sm font-semibold text-gray-600 uppercase">
                  {orderSummaryData?.orderSummary?.deliveryCharges === 0.0
                    ? "Free"
                    : country + " " + orderSummaryData?.orderSummary?.deliveryCharges.toFixed(2)}
                </div>
              </div>
            </div>
            <hr className="w-full border border-slate-500 mt-6  "></hr>
            <div className="flex w-full pt-3">
              <div className="md:text-xl text-xl font-bold text-gray-500">Total</div>
              <div className="w-full flex justify-end md:text-xl text-xl font-bold text-gray-500 uppercase">
                {country + " " + (orderSummaryData?.orderSummary?.totalOrderValue.toFixed(2) || "0")}
              </div>
            </div>
            {!orderSummaryData?.orderSummary?.placeOrder && (
              <div className="relative space-y-1 p-2 mt-4 bg-red-600 rounded-md">
                <p className="flex justify-center font-bold text-sm text-white">
                  Minimum order size is {orderSummaryData?.orderSummary?.minimumOrderSize}
                </p>
                <p className="flex justify-center font-semibold text-xs text-white">
                  (Masks & packages of Labels combined)
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderSummary;
